import { styled } from '@mui/system'
import { NavLink } from 'react-router-dom'
import { BORDER_RADIUSES, colors, fontSizes } from '../../Constants/consts'

export const Nav = styled('nav')({
  backgroundColor: colors.navSecondary,
  borderBottom: `1px solid ${colors.navBorder}`,
})

export const NavHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(0, 2),
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'flex-start',
    overflowX: 'auto',
    '&::-webkit-scrollbar': { display: 'none' },
    scrollbarWidth: 'none' as const,
  },
}))

export const LogoLink = styled(NavLink)({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  flexShrink: 0,
})

export const LogoIcon = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginLeft: theme.spacing(1),
  marginBottom: theme.spacing(0.5),
  '& img': {
    height: 28,
    width: 'auto',
    maxWidth: 120,
  },
  [theme.breakpoints.down('md')]: {
    marginLeft: theme.spacing(0.5),
    '& img': {
      height: 24,
      maxWidth: 100,
    },
  },
  [theme.breakpoints.down('sm')]: {
    marginLeft: theme.spacing(0.25),
    '& img': {
      height: 20,
      maxWidth: 80,
    },
  },
}))

export const NavLinkContainer = styled('div')({
  textAlign: 'center',
})

export const NavLinks = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(0.5),
  margin: theme.spacing(1.5, 2, 0),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(1.5, 1, 0),
    gap: 0,
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(1.5, 0.5, 0),
  },
}))

export const StyledNavLink = styled(NavLink)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  textDecoration: 'none',
  padding: theme.spacing(1.25, 2),
  color: colors.gray.gray40,
  textAlign: 'center',
  fontSize: fontSizes.small,
  fontWeight: 600,
  letterSpacing: '0.06em',
  textTransform: 'uppercase' as const,
  transition: 'color 0.15s ease',
  position: 'relative',
  whiteSpace: 'nowrap',
  '&:hover': {
    color: colors.white,
  },
  '&:focus': {
    outline: 'none',
  },
  '&:focus-visible': {
    outline: `2px solid ${colors.yellow}`,
    outlineOffset: 2,
    borderRadius: BORDER_RADIUSES.xSmall,
  },
  [theme.breakpoints.down('md')]: {
    fontSize: fontSizes.xSmall,
    padding: theme.spacing(1, 1),
    letterSpacing: '0.04em',
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1, 0.75),
  },
  '&.active': {
    color: colors.white,
    fontWeight: 700,
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: theme.spacing(2),
      right: theme.spacing(2),
      height: 3,
      background: colors.yellow,
      borderRadius: '2px 2px 0 0',
      [theme.breakpoints.down('md')]: {
        left: theme.spacing(1),
        right: theme.spacing(1),
        height: 2,
      },
    },
  },
}))
